/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Index from "views/Index.js";
import Profile from "views/users/Profile.js";
import Available from "views/scripts/Available";
import Assigned from "views/scripts/Assigned";
import Marked from "views/scripts/Marked";
import Login from "views/auth/Login.js";
import ScriptView from "views/scripts/ScriptView";
import VideoPlayer from "views/scripts/VideoPlayer";
import AddMarker from "views/users/AddMarker";
import MarkedScriptView from "views/scripts/MarkedScriptView";
import StudentMarkedScriptView from "views/scripts/StudentMarkedScriptView";
import MarkedScriptEdit from "views/scripts/MarkedScriptEdit";
var routes = [
  {
    path: "/index",
    name: "Dashboard",
    icon: "ni ni-tv-2 text-primary",
    component: Index,
    layout: "/admin"
  },
  {
    path: "/available",
    name: "Available Scripts",
    icon: "ni ni-bullet-list-67",
    component: Available,
    layout: "/admin"
  },
  {
    path: "/assigned",
    name: "Assigned",
    icon: "ni ni-chart-pie-35",
    component: Assigned,
    layout: "/admin"
  },
  {
    path: "/marked",
    name: "Marked Scripts",
    icon: "ni ni-book-bookmark",
    component: Marked,
    layout: "/admin"
  },
  {
    path: "/users",
    name: "Markers",
    icon: "fa fa-users",
    component: AddMarker,
    layout: "/admin"
  } ,
  {
    path: "/profile",
    name: "My Profile",
    icon: "fa fa-id-card",
    component: Profile,
    layout: "/admin"
  } ,  
  {
    path: "/mark_script/:upload_id/:page_number",
    name: "Script Viewer",
    icon: "fa fa-id-card",
    component: ScriptView,
    layout: "/admin"
  } ,
  {
    path: "/view_marked/:upload_id/:page_number",
    name: "Script Viewer",
    icon: "fa fa-id-card",
    component: MarkedScriptView,
    layout: "/admin"
  } ,
  {
    path: "/edit_marked/:upload_id/:page_number",
    name: "Script Editor",
    icon: "fa fa-id-card",
    component: MarkedScriptEdit,
    layout: "/admin"
  } ,
  {
    path: "/student-view-script/:upload_id/:page_number",
    name: "Script Viewer",
    icon: "fa fa-id-card",
    component: StudentMarkedScriptView,
    layout: "/admin"
  } ,
  
  {
    path: "/login",
    name: "Login",
    icon: "ni ni-key-25 text-info",
    component: Login,
    layout: "/auth"
  },
  {
    path: "/play_video/:upload_id",
    name: "Video Player",
    icon: "ni ni-key-25 text-info",
    component: VideoPlayer,
    layout: "/admin"
  },
];
export default routes;
